export default {
  img: {
    maxWidth: '100%'
  }
}



// WEBPACK FOOTER //
// ./src/assets/globalStyles/image.js